import {getLidSize} from "containers/domain/lid";
import {Plan, Manhole} from "types";

export interface LidGeometry {
    // lid canvas box
    left: number;
    right: number;
    top: number;
    bottom: number;
    width: number;
    height: number;
    // clear opening
    clearLeft: number;
    clearRight: number;
}

export function createLidGeometry(plan: Plan, manholes: Manhole[], scale: number, side: string): LidGeometry {
    const getLidTop = () => 0
    const getLidHeight = () => getLidSize(plan, manholes).height * scale
    const getLidBottom = () => getLidTop() + getLidHeight()
    const getLidLeft = () => 0
    const getLidWidth = () => {
        return side === 'left' || side === 'right'
            ? getLidSize(plan, manholes).width * scale
            : getLidSize(plan, manholes).length * scale
    }
    const getLidRight = () => getLidLeft() + getLidWidth()
    const getClearMeasureLeft = () => {
        return side === 'left' ? (getLidSize(plan, manholes).width - plan.width + getLidSize(plan, manholes).y) * scale
            : side === 'right' ? -getLidSize(plan, manholes).y * scale
                : side === 'front' ? -getLidSize(plan, manholes).x * scale
                    : side === 'back'
                        ? (getLidSize(plan, manholes).length - plan.length + getLidSize(plan, manholes).x) * scale
                        : 0
    }
    const getClearMeasureRight = () => {
        return side === 'left' || side === 'right' ? getClearMeasureLeft() + plan.width * scale
            : side === 'front' || side === 'back' ? getClearMeasureLeft() + plan.length * scale
                : 0
    }

    return {
        left: getLidLeft(), right: getLidRight(), top: getLidTop(),  bottom: getLidBottom(),
        width: getLidWidth(), height: getLidHeight(),
        clearLeft: getClearMeasureLeft(), clearRight: getClearMeasureRight(),
    };
}